import api from "utilities/Axios";
export const getAllHealth = () => {
  return api.get("/Health/GetAll");
};

export const refreshHealth = (id: any) => {
  return api.get("/Health/Get" + `?type=${id}`);
};
